import { Injectable } from '@angular/core';
import { IPriorityShape, ISeatsPlan, IShape } from '../../interfaces';
import { CreatorStateService } from './CreatorStateService';

@Injectable({
  providedIn: 'root'
})
export class CreatorCacheService {

  public static seatsPlansCacheMap = new Map<number, {
    initState: ISeatsPlan,
    seatsPlan: ISeatsPlan,
    deleteElementsIds: number[],
  }>();

  public static shapesCache = new Map<number, {
    libraryShapes: IShape[],
    sectorsShapes: IShape[]
  }>();

  public static priorityCacheMap = new Map<number, {
    priorityShape: IPriorityShape,
    initPriorityShape: IPriorityShape,
    seatsGuidsWithManualPriority: string[],
  }>();

  public static makeSnapshot(): void {
    CreatorCacheService.seatsPlansCacheMap.set(CreatorStateService.sectorId, {
      initState: CreatorStateService.initSeatsPlanState,
      seatsPlan: CreatorStateService.seatsPlan,
      deleteElementsIds: CreatorStateService.deleteElementsIds,
    });
  }

  public static cacheShapes(): void {
    CreatorCacheService.shapesCache.set(CreatorStateService.sectorId, {
      libraryShapes: CreatorStateService.libraryShapes,
      sectorsShapes: CreatorStateService.sectorsShapes
    });
  }

  public static cachePriority(): void {
    CreatorCacheService.priorityCacheMap.set(CreatorStateService.sectorId, {
      priorityShape: CreatorStateService.priorityShape,
      initPriorityShape: CreatorStateService.initPriorityShape,
      seatsGuidsWithManualPriority: CreatorStateService.seatsGuidsWithManualPriority,
    });
  }

  public static clearCache(): void {
    CreatorCacheService.seatsPlansCacheMap.clear();
  }
}
